import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import mutations from './mutations';
import actions from './actions';
import * as getters from './getters';
// vuex插件 操作vuex 自动打印日志
import createLogger from 'vuex/dist/logger';


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    // 调试
    // stric: debug,
    plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/store/index.js